import { render, staticRenderFns } from "./CloudflareVideoPlayer.vue?vue&type=template&id=0c358b52&"
import script from "./CloudflareVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./CloudflareVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./CloudflareVideoPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports